(function () {
  var roots = document.querySelectorAll('[data-mkf]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    if (root.__mkfReady) return;
    root.__mkfReady = true;
    initConfigurator(root);
  });

  function initConfigurator(root) {
    var schema = readJson(root, '[data-mkf-schema]', {});
    var ral = readJson(root, '[data-mkf-ral]', []);
    var imageMatrix = readJson(root, '[data-mkf-image-matrix]', {});
    var media = readJson(root, '[data-mkf-media]', []);
    if (!Array.isArray(ral)) ral = [];
    if (!imageMatrix || typeof imageMatrix !== 'object' || Array.isArray(imageMatrix)) imageMatrix = {};
    if (!Array.isArray(media)) media = [];

    var baseVariant = parseInt(root.getAttribute('data-base-variant'), 10);
    var basePriceCents = parsePriceCents(root.getAttribute('data-base-price'), true);
    if (!basePriceCents && schema.base_price) basePriceCents = parsePriceCents(schema.base_price, false);
    var baseAvailable = root.getAttribute('data-base-available') === 'true';
    var productTitle = root.getAttribute('data-title') || '';
    var lieferzeit = root.getAttribute('data-lieferzeit') || '';

    var refs = {
      steps: root.querySelector('[data-mkf-steps]'),
      image: root.querySelector('[data-mkf-image]'),
      imageNote: root.querySelector('[data-mkf-image-note]'),
      total: root.querySelector('[data-mkf-total]'),
      summary: root.querySelector('[data-mkf-summary]'),
      add: root.querySelector('[data-mkf-add]'),
      status: root.querySelector('[data-mkf-status]')
    };

    var fallbackImage = media[0] || null;
    var imageMatrixItems = imageMatrix.items && typeof imageMatrix.items === 'object' ? imageMatrix.items : {};
    var addOns = {};
    var state = {};
    var removedNote = '';
    var isAdding = false;

    var steps = Array.isArray(schema.steps) ? schema.steps : [];
    steps.forEach(function (step) {
      state[step.id] = isMultiStep(step) ? { values: [] } : { value: null };
    });

    var handles = collectHandles(steps, ral);
    preloadImages(media.map(function (item) { return item && item.url; }));

    fetchAddOns(handles).then(function (result) {
      addOns = result;
      initializeDefaults();
      render();
    });

    refs.add.addEventListener('click', addToCart);

    // Keep floating support controls above the actual, wrapping purchase bar.
    var dock = root.querySelector('[data-mkf-dock]');
    if (dock) {
      var updateDockHeight = function () {
        document.documentElement.style.setProperty('--chocolat-machine-dock-height', Math.ceil(dock.getBoundingClientRect().height) + 'px');
      };
      updateDockHeight();
      if (window.ResizeObserver) {
        new ResizeObserver(updateDockHeight).observe(dock);
      } else {
        window.addEventListener('resize', updateDockHeight);
      }
    }


    function render() {
      enforceState();
      refs.steps.innerHTML = '';

      steps.forEach(function (step, index) {
        refs.steps.appendChild(renderStep(step, index + 1));
      });

      updateVisual();
      updateTotals();
    }

    function renderStep(step, number) {
      var enabled = dependencyMet(step);
      var section = document.createElement('section');
      section.className = 'mkf__step' + (enabled ? '' : ' is-disabled');
      section.setAttribute('data-step-id', step.id);

      var head = document.createElement('div');
      head.className = 'mkf__step-head';
      head.innerHTML =
        '<span class="mkf__step-no">' + number + '</span>' +
        '<div><h2 class="mkf__step-title">' + escapeHtml(step.label || step.id) + '</h2>' +
        (step.copy ? '<p class="mkf__step-copy">' + escapeHtml(step.copy) + '</p>' : '') +
        '</div>';
      section.appendChild(head);

      if (!enabled) {
        section.appendChild(hintBox(
          'Nicht mit der aktuellen Auswahl möglich',
          step.disabled_hint || step.dependency_hint || 'Diese Option wird aktiv, sobald die passende technische Grundlage gewählt ist.'
        ));
      }

      if (isSwatchStep(step)) {
        section.appendChild(renderSwatches(step, enabled));
      } else {
        section.appendChild(renderChoices(step, enabled));
      }

      var info = selectedInfo(step);
      if (info) section.appendChild(hintBox(info.title, info.text));

      if (step.id === 'water' && !enabled) {
        section.appendChild(hintBox('Rotationspumpe erforderlich', 'Festwasser und Abwasser sind nur mit Rotationspumpe möglich.'));
      }

      if (removedNote && /water|wasser|ablauf/i.test(step.id)) {
        section.appendChild(warningBox('Auswahl angepasst', removedNote));
      }

      if (isCustomRalSelected(step)) {
        section.appendChild(renderCustomRal(step, enabled));
      }

      return section;
    }

    function renderChoices(step, enabled) {
      var wrap = document.createElement('div');
      wrap.className = 'mkf__choices';
      var choices = getChoices(step);
      var rendered = 0;

      choices.forEach(function (choice) {
        if (shouldHideChoice(step, choice)) return;
        rendered += 1;

        var selected = isSelected(step, choice);
        var disabled = !enabled || choiceUnavailable(choice);
        var button = document.createElement('button');
        button.type = 'button';
        var choiceImage = absoluteShopifyImage(choice.swatchImage);
        button.className = 'mkf__choice' + (choiceImage ? ' has-image' : '');
        button.disabled = disabled;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.innerHTML =
          (choiceImage
            ? '<span class="mkf__choice-media"><img src="' + escapeHtml(choiceImage) + '" alt="' + escapeHtml(choice.label) + '" loading="lazy"></span>'
            : '') +
          '<span class="mkf__choice-body">' +
            '<span class="mkf__choice-label">' + escapeHtml(choice.label) + '</span>' +
            '<span class="mkf__price">' + escapeHtml(priceLabel(choice)) + '</span>' +
            (choice.sub ? '<span class="mkf__choice-sub">' + escapeHtml(choice.sub) + '</span>' : '') +
          '</span>';
        button.addEventListener('click', function () {
          toggleChoice(step, choice);
          render();
        });
        wrap.appendChild(button);
      });

      if (!rendered) {
        wrap.appendChild(warningBox('Noch nicht verfügbar', step.empty_text || 'Für diese Gruppe sind aktuell keine aktiven Shopify-Produkte verfügbar.'));
      }

      return wrap;
    }

    function renderSwatches(step, enabled) {
      var wrap = document.createElement('div');
      wrap.className = 'mkf__choices--swatches';
      var choices = getChoices(step);

      choices.forEach(function (choice) {
        if (shouldHideChoice(step, choice)) return;

        var selected = isSelected(step, choice);
        var disabled = !enabled || choiceUnavailable(choice);
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'mkf__swatch';
        button.disabled = disabled;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');

        var mediaEl = document.createElement('span');
        mediaEl.className = 'mkf__swatch-media';
        applySwatchBackground(mediaEl, choice);

        var body = document.createElement('span');
        body.className = 'mkf__swatch-body';
        body.innerHTML =
          '<span class="mkf__swatch-label">' + escapeHtml(choice.label) + '</span>' +
          (choice.code ? '<span class="mkf__swatch-code">' + escapeHtml(choice.code) + '</span>' : '') +
          '<span class="mkf__price">' + escapeHtml(priceLabel(choice)) + '</span>';

        button.appendChild(mediaEl);
        button.appendChild(body);
        button.addEventListener('click', function () {
          toggleChoice(step, choice);
          render();
        });
        wrap.appendChild(button);
      });

      return wrap;
    }

    function renderCustomRal(step, enabled) {
      var selected = selectedChoice(step);
      var box = document.createElement('div');
      box.className = 'mkf__custom';

      var row = document.createElement('div');
      row.className = 'mkf__fieldrow';

      var fieldWrap = document.createElement('label');
      fieldWrap.className = 'mkf__fieldwrap';
      fieldWrap.innerHTML = '<span class="mkf__label">RAL-Code</span>';

      var input = document.createElement('input');
      input.className = 'mkf__field';
      input.inputMode = 'numeric';
      input.pattern = '[0-9]*';
      input.maxLength = 4;
      input.placeholder = '5021';
      input.value = (state[step.id] && state[step.id].customCode) || '';
      input.disabled = !enabled;
      input.addEventListener('input', function () {
        state[step.id].customCode = input.value.replace(/[^0-9]/g, '').slice(0, 4);
        input.value = state[step.id].customCode;
        updateTotals();
      });
      fieldWrap.appendChild(input);
      row.appendChild(fieldWrap);

      var finishes = document.createElement('div');
      finishes.className = 'mkf__finishes';
      getFinishes(step, selected).forEach(function (finish) {
        var selectedFinish = (state[step.id] && state[step.id].finish) || getFinishes(step, selected)[0].value;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'mkf__finish';
        button.disabled = !enabled;
        button.setAttribute('aria-pressed', selectedFinish === finish.value ? 'true' : 'false');
        button.textContent = finish.label;
        button.addEventListener('click', function () {
          state[step.id].finish = finish.value;
          render();
        });
        finishes.appendChild(button);
      });
      row.appendChild(finishes);
      box.appendChild(row);
      box.appendChild(hintBox('RAL nach Wunsch', 'Wir stimmen den finalen Farbton nach deiner Bestellung persönlich mit dir ab.'));
      return box;
    }

    function initializeDefaults() {
      steps.forEach(function (step) {
        if (isMultiStep(step)) return;
        var current = state[step.id] && state[step.id].value;
        if (current) return;
        var choices = getChoices(step).filter(function (choice) {
          return !choiceUnavailable(choice);
        });
        if (!choices.length) return;
        var explicit = findDefaultChoice(step, choices);
        if (explicit) setSingle(step, explicit);
      });
    }

    function enforceState() {
      steps.forEach(function (step) {
        if (!dependencyMet(step)) {
          if (hasAnySelection(step)) {
            clearStep(step);
            removedNote = step.removed_hint || 'Eine nicht kompatible Auswahl wurde entfernt.';
          }
          return;
        }

        if (isMultiStep(step)) {
          var next = (state[step.id].values || []).filter(function (value) {
            var choice = getChoices(step).find(function (item) { return item.value === value; });
            return choice && !choiceUnavailable(choice);
          });
          state[step.id].values = next;
          return;
        }

        var choice = selectedChoice(step);
        if (choice && choiceUnavailable(choice)) clearStep(step);
        if (!selectedChoice(step) && step.required !== false) {
          var defaults = getChoices(step).filter(function (item) { return !choiceUnavailable(item); });
          var fallback = findDefaultChoice(step, defaults);
          if (fallback) setSingle(step, fallback);
        }
      });
    }

    function updateVisual() {
      var colorStep = steps.find(isSwatchStep);
      var choice = colorStep ? selectedChoice(colorStep) : null;
      var matrixItem = selectedMatrixImage();
      var next = matrixItem && matrixItem.url ? absoluteShopifyImage(matrixItem.url) : (choice && imageForChoice(choice));
      if (!next && fallbackImage) next = fallbackImage.url;

      if (!refs.image || !next) return;
      var current = refs.image.getAttribute('src') || '';
      if (current !== next) {
        refs.image.classList.add('is-switching');
        preloadImage(next, function () {
          refs.image.setAttribute('src', next);
          refs.image.setAttribute('alt', (matrixItem && matrixItem.alt) || imageAlt(choice));
          window.setTimeout(function () {
            refs.image.classList.remove('is-switching');
          }, 80);
        });
      }

      if (choice && !imageForChoice(choice) && refs.imageNote) {
        refs.imageNote.textContent = choice.kind === 'custom'
          ? 'Die finale RAL-Farbe wird nach deiner Bestellung persönlich abgestimmt. Bis dahin zeigen wir die Referenzansicht.'
          : 'Für diese Farbe ist noch kein separates Maschinenbild hinterlegt. Die Auswahl bleibt im Warenkorb erhalten.';
        refs.imageNote.hidden = false;
        if (window.console && window.console.warn) {
          window.console.warn('[MKF] Missing machine image for color option:', choice.value);
        }
      } else if (refs.imageNote) {
        refs.imageNote.hidden = true;
      }
    }

    function updateTotals() {
      var selection = collectSelection();
      var totalPrice = formatCurrency(basePriceCents + selection.extraCents);
      refs.total.textContent = totalPrice;
      refs.add.textContent = 'In den Warenkorb · ' + totalPrice;
      refs.summary.innerHTML = escapeHtml(selection.summary.join(' · '));
      if (lieferzeit) {
        refs.summary.innerHTML += '<br><span>' + escapeHtml(lieferzeitLabel(lieferzeit)) + '</span>';
      }

      var problems = selection.problems.slice();
      if (!baseVariant) problems.unshift('Basisvariante fehlt.');
      if (!baseAvailable) problems.unshift('Basisprodukt aktuell nicht kaufbar. Bestand/Weiterverkauf muss im Shopify Admin korrigiert werden.');

      refs.add.disabled = isAdding || problems.length > 0;
      refs.status.textContent = problems.length ? problems.join(' ') : '';
    }

    function collectSelection() {
      var props = {};
      var lines = new Map();
      var summary = [];
      var problems = [];
      var extraCents = 0;

      steps.forEach(function (step) {
        if (!dependencyMet(step)) return;
        var label = step.cart_label || step.label || step.id;

        if (isMultiStep(step)) {
          var selected = selectedChoices(step);
          if (step.required && !selected.length) problems.push('Bitte wähle noch: ' + label + '.');
          if (selected.length) {
            props[label] = selected.map(displayValue).join(', ');
            summary.push(label + ': ' + selected.map(function (choice) { return choice.label; }).join(', '));
            selected.forEach(function (choice) {
              var charged = addChoiceLine(choice, lines);
              extraCents += charged.extraCents;
              problems = problems.concat(charged.problems);
            });
          }
          return;
        }

        var choice = selectedChoice(step);
        if (!choice) {
          if (step.required !== false) problems.push('Bitte wähle noch: ' + label + '.');
          return;
        }

        props[label] = displayValue(choice);
        summary.push(label + ': ' + choice.label);

        if (isCustomRal(choice)) {
          var code = (state[step.id] && state[step.id].customCode) || '';
          if (!/^[0-9]{4}$/.test(code)) {
            problems.push('Bitte trage einen vierstelligen RAL-Code ein.');
          } else {
            props['RAL-Code'] = code;
            props['RAL-Finish'] = finishLabel(step, choice);
          }
        }

        if (isPersonalLogo(choice)) {
          props['Logo-Datei'] = 'Abstimmung nach Bestellung';
        }

        var chargedSingle = addChoiceLine(choice, lines);
        extraCents += chargedSingle.extraCents;
        problems = problems.concat(chargedSingle.problems);
      });

      return {
        props: props,
        lines: Array.from(lines.values()),
        summary: summary,
        problems: problems,
        extraCents: extraCents
      };
    }

    function addChoiceLine(choice, lines) {
      var result = { extraCents: 0, problems: [] };
      if (!choice.addon_handle) {
        if (choice.priceCents > 0) {
          result.problems.push('Für "' + choice.label + '" fehlt ein aktives Shopify-Add-on.');
        }
        return result;
      }

      var addOn = addOns[choice.addon_handle];
      if (!addOn || !addOn.id || !addOn.available) {
        result.problems.push('"' + choice.label + '" ist im Shop noch nicht als kaufbares Add-on aktiv.');
        return result;
      }

      if (!lines.has(addOn.id)) {
        lines.set(addOn.id, {
          id: addOn.id,
          label: choice.line_label || choice.label,
          priceCents: addOn.priceCents,
          custom: choice.customLineProperties || {}
        });
        result.extraCents += addOn.priceCents;
      }
      return result;
    }

    function addToCart() {
      var selection = collectSelection();
      if (refs.add.disabled || selection.problems.length || isAdding) return;

      isAdding = true;
      refs.add.disabled = true;
      refs.add.textContent = 'Wird hinzugefügt';
      refs.status.textContent = '';

      var bundleId = 'cfg-' + Date.now() + '-' + Math.floor(Math.random() * 9999);
      var items = [{
        id: baseVariant,
        quantity: 1,
        properties: Object.assign({ _bundle: bundleId }, selection.props)
      }];

      selection.lines.forEach(function (line) {
        items.push({
          id: line.id,
          quantity: 1,
          properties: Object.assign({
            _bundle: bundleId,
            'Für': productTitle,
            Option: line.label
          }, line.custom || {})
        });
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () { return {}; }).then(function (body) {
            throw new Error(body.description || body.message || 'Konnte nicht in den Warenkorb legen.');
          });
        }
        return response.json();
      }).then(function () {
        refs.status.textContent = 'Konfiguration wurde hinzugefügt.';
        window.location.href = '/cart';
      }).catch(function (error) {
        isAdding = false;
        refs.add.textContent = 'In den Warenkorb';
        updateTotals();
        refs.status.textContent = error instanceof TypeError
          ? 'Die Verbindung zum Warenkorb ist fehlgeschlagen. Bitte prüfe deine Internetverbindung und versuche es erneut.'
          : (error.message || 'Konnte nicht in den Warenkorb legen.');
      });
    }

    function getChoices(step) {
      if (isSwatchStep(step)) {
        var swatches = ral.length ? ral : (step.choices || []);
        return swatches.map(function (item) { return normalizeChoice(item, step, true); });
      }
      return (step.choices || []).map(function (item) { return normalizeChoice(item, step, false); });
    }

    function normalizeChoice(item, step, isSwatch) {
      var value = item.value || item.code || item.handle || item.addon_handle || item.label || item.name_de || '';
      var label = item.label || item.name_de || item.name || item.title || value;
      var handle = item.addon_handle || item.handle || null;
      var addOn = handle ? addOns[handle] : null;
      var priceCents = item.price_cents != null
        ? parsePriceCents(item.price_cents, true)
        : (addOn ? addOn.priceCents : parsePriceCents(item.price, false));

      return {
        value: slug(value),
        rawValue: value,
        code: item.code || null,
        label: label,
        sub: item.sub || item.description || '',
        kind: item.kind || (isSwatch ? 'swatch' : 'option'),
        finish: item.finish || null,
        addon_handle: handle,
        priceCents: priceCents,
        default: Boolean(item.default) || matchesDefault(step, value, label, handle),
        disabled: Boolean(item.disabled),
        hide: Boolean(item.hide),
        info: item.info || item.hint || '',
        info_title: item.info_title || item.hint_title || '',
        image: item.machine_image || item.image || item.product_image || null,
        swatchImage: item.swatch_image || item.img || (addOn && addOn.img) || null,
        hex: item.hex || item.color || null,
        finishes: item.finishes || item.custom_finishes || null,
        line_label: item.line_label || null,
        customLineProperties: item.custom_line_properties || null
      };
    }

    function collectHandles(stepList, swatches) {
      var out = [];
      stepList.forEach(function (step) {
        (step.choices || []).forEach(function (choice) {
          var h = choice.addon_handle || choice.handle;
          if (h) out.push(h);
        });
      });
      swatches.forEach(function (swatch) {
        var h = swatch.addon_handle || swatch.handle;
        if (h) out.push(h);
      });
      return unique(out);
    }

    function fetchAddOns(handlesList) {
      var result = {};
      return Promise.all(handlesList.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (response) { return response.ok ? response.json() : null; })
          .then(function (product) {
            if (!product || !product.variants || !product.variants[0]) return;
            var variant = product.variants[0];
            result[handle] = {
              id: variant.id,
              priceCents: Number(variant.price) || 0,
              available: product.available !== false && variant.available !== false,
              img: absoluteShopifyImage(product.featured_image || (product.images && product.images[0]) || null)
            };
            if (result[handle].img) preloadImage(result[handle].img);
          }).catch(function () {});
      })).then(function () {
        return result;
      });
    }

    function toggleChoice(step, choice) {
      removedNote = '';
      if (isMultiStep(step)) {
        var selected = state[step.id].values || [];
        if (selected.indexOf(choice.value) >= 0) {
          state[step.id].values = selected.filter(function (value) { return value !== choice.value; });
        } else {
          state[step.id].values = selected.concat(choice.value);
        }
        return;
      }
      setSingle(step, choice);
    }

    function setSingle(step, choice) {
      var existing = state[step.id] || {};
      state[step.id] = {
        value: choice.value,
        customCode: existing.customCode || '',
        finish: existing.finish || firstFinishValue(step, choice)
      };
      if (!isCustomRal(choice)) {
        state[step.id].customCode = '';
      }
    }

    function clearStep(step) {
      state[step.id] = isMultiStep(step) ? { values: [] } : { value: null };
    }

    function selectedChoice(step) {
      var value = state[step.id] && state[step.id].value;
      if (!value) return null;
      return getChoices(step).find(function (choice) { return choice.value === value; }) || null;
    }

    function selectedChoices(step) {
      var values = (state[step.id] && state[step.id].values) || [];
      return getChoices(step).filter(function (choice) { return values.indexOf(choice.value) >= 0; });
    }

    function isSelected(step, choice) {
      if (isMultiStep(step)) {
        return ((state[step.id] && state[step.id].values) || []).indexOf(choice.value) >= 0;
      }
      return Boolean(state[step.id] && state[step.id].value === choice.value);
    }

    function hasAnySelection(step) {
      if (isMultiStep(step)) return Boolean(state[step.id] && state[step.id].values && state[step.id].values.length);
      return Boolean(state[step.id] && state[step.id].value);
    }

    function choiceUnavailable(choice) {
      if (choice.disabled) return true;
      if (!choice.addon_handle) return false;
      var addOn = addOns[choice.addon_handle];
      return !addOn || !addOn.available;
    }

    function shouldHideChoice(step, choice) {
      if (choice.hide) return true;
      return Boolean((step.hide_unavailable || step.hideUnavailable) && choiceUnavailable(choice));
    }

    function dependencyMet(step) {
      var dep = step.depends_on || step.dependsOn;
      if (!dep) return true;
      if (Array.isArray(dep)) return dep.every(dependencyRuleMet);
      return dependencyRuleMet(dep);
    }

    function dependencyRuleMet(rule) {
      if (!rule) return true;
      var depStep = steps.find(function (item) { return item.id === (rule.step || rule.id); });
      if (!depStep) return true;
      var allowed = rule.values || (rule.value != null ? [rule.value] : []);
      allowed = allowed.map(slug);
      if (!allowed.length) return hasAnySelection(depStep);

      if (isMultiStep(depStep)) {
        return selectedChoices(depStep).some(function (choice) {
          return choiceMatches(choice, allowed);
        });
      }
      var choice = selectedChoice(depStep);
      return choice ? choiceMatches(choice, allowed) : false;
    }

    function choiceMatches(choice, allowed) {
      return [choice.value, choice.rawValue, choice.code, choice.label, choice.addon_handle].some(function (value) {
        return allowed.indexOf(slug(value || '')) >= 0;
      });
    }

    function findDefaultChoice(step, choices) {
      return choices.find(function (choice) { return choice.default; }) || (step.required === false ? null : choices[0]);
    }

    function matchesDefault(step, value, label, handle) {
      var def = step.default || step.default_value || step.defaultValue || step.default_code || step.defaultCode;
      if (!def) return false;
      var normalized = slug(def);
      return [value, label, handle].some(function (item) { return slug(item || '') === normalized; });
    }

    function selectedInfo(step) {
      var choice = selectedChoice(step);
      if (!choice) return null;
      if (choice.info) {
        return { title: choice.info_title || 'Hinweis', text: choice.info };
      }
      if (isPersonalLogo(choice)) {
        return {
          title: 'Personalisiertes Logo',
          text: 'Für ein personalisiertes Logo melden wir uns nach der Bestellung zur finalen Abstimmung.'
        };
      }
      if (isCustomRal(choice)) {
        return {
          title: 'RAL nach Wunsch',
          text: 'RAL nach Wunsch: Wir stimmen den finalen Farbton nach deiner Bestellung persönlich mit dir ab.'
        };
      }
      return step.hint ? { title: step.hint_title || 'Hinweis', text: step.hint } : null;
    }

    function displayValue(choice) {
      var text = choice.label;
      if (choice.code && choice.code !== choice.label) text += ' (' + choice.code + ')';
      return text;
    }

    function priceLabel(choice) {
      if (choice.addon_handle && choiceUnavailable(choice)) return 'nicht aktiv';
      if (choice.priceCents > 0) return '+' + formatCurrency(choice.priceCents);
      if (choice.priceCents < 0) return formatCurrency(choice.priceCents);
      return 'inkl.';
    }

    function imageForChoice(choice) {
      return absoluteShopifyImage(choice.image || choice.machine_image || null);
    }

    function selectedMatrixImage() {
      if (!Object.keys(imageMatrixItems).length) return null;

      var colorStep = steps.find(isSwatchStep);
      var colorChoice = colorStep ? selectedChoice(colorStep) : null;
      if (!colorChoice) return null;

      var colorKey = matrixKeyForChoice(colorChoice);
      var woodStep = steps.find(function (step) { return step.id === 'wood'; });
      var woodChoice = woodStep ? selectedChoice(woodStep) : null;
      var woodKey = woodChoice ? matrixKeyForChoice(woodChoice) : null;
      var controlStep = steps.find(function (step) { return step.id === 'control'; });
      var controlChoice = controlStep ? selectedChoice(controlStep) : null;
      var controlKey = controlChoice ? matrixKeyForChoice(controlChoice) : null;

      var keys = [];
      if (colorKey && woodKey && controlKey) keys.push(colorKey + '|' + woodKey + '|' + controlKey);
      if (colorKey && woodKey) keys.push(colorKey + '|' + woodKey);
      if (colorKey) keys.push(colorKey);

      for (var i = 0; i < keys.length; i += 1) {
        if (imageMatrixItems[keys[i]]) return imageMatrixItems[keys[i]];
      }
      return null;
    }

    function matrixKeyForChoice(choice) {
      return choice ? slug(choice.value || choice.rawValue || choice.code || choice.label || choice.addon_handle || '') : '';
    }

    function imageAlt(choice) {
      if (!choice) return productTitle;
      return productTitle + ' in ' + choice.label;
    }

    function applySwatchBackground(el, choice) {
      var img = absoluteShopifyImage(choice.swatchImage);
      if (img) {
        el.style.backgroundImage = 'url("' + img + '")';
        return;
      }
      if (choice.hex) {
        el.style.background = choice.hex;
        return;
      }
      el.style.background = '#eee';
    }

    function isSwatchStep(step) {
      return step.type === 'swatch-ral' || step.type === 'swatches' || step.id === 'color';
    }

    function isMultiStep(step) {
      return step.type === 'multiselect' || step.type === 'accessories' || step.multiple === true;
    }

    function isCustomRal(choice) {
      return Boolean(choice && (
        choice.kind === 'custom' ||
        /custom|eigene|wunsch/.test(String(choice.rawValue + ' ' + choice.label).toLowerCase())
      ));
    }

    function isCustomRalSelected(step) {
      return isCustomRal(selectedChoice(step));
    }

    function isPersonalLogo(choice) {
      return Boolean(choice && /personal|custom|e7104/i.test(String(choice.rawValue + ' ' + choice.label)));
    }

    function getFinishes(step, choice) {
      var list = (choice && choice.finishes) || step.custom_finishes || step.finishes || [
        { value: 'strukturiert', label: 'Strukturiert' },
        { value: 'glaenzend', label: 'Glänzend' }
      ];
      return list.map(function (item) {
        if (typeof item === 'string') return { value: slug(item), label: item };
        return { value: item.value || slug(item.label), label: item.label || item.value };
      });
    }

    function firstFinishValue(step, choice) {
      var finishes = getFinishes(step, choice);
      return finishes[0] ? finishes[0].value : '';
    }

    function finishLabel(step, choice) {
      var selected = (state[step.id] && state[step.id].finish) || firstFinishValue(step, choice);
      var item = getFinishes(step, choice).find(function (finish) { return finish.value === selected; });
      return item ? item.label : selected;
    }

    function hintBox(title, text) {
      var box = document.createElement('div');
      box.className = 'mkf__hintbox';
      box.innerHTML = '<strong>' + escapeHtml(title) + '</strong><span>' + escapeHtml(text) + '</span>';
      return box;
    }

    function warningBox(title, text) {
      var box = document.createElement('div');
      box.className = 'mkf__warning';
      box.innerHTML = '<strong>' + escapeHtml(title) + '</strong><span>' + escapeHtml(text) + '</span>';
      return box;
    }
  }

  function readJson(root, selector, fallback) {
    var node = root.querySelector(selector);
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent || '');
    } catch (error) {
      if (window.console && window.console.warn) window.console.warn('[MKF] Invalid JSON:', selector, error);
      return fallback;
    }
  }

  function parsePriceCents(value, alreadyCents) {
    if (value == null || value === '') return 0;
    var number;
    if (typeof value === 'number') {
      number = value;
    } else {
      var raw = String(value).trim();
      var normalized = raw.indexOf(',') >= 0
        ? raw.replace(/\./g, '').replace(',', '.')
        : raw;
      number = parseFloat(normalized);
    }
    if (!Number.isFinite(number)) return 0;
    return Math.round(alreadyCents ? number : number * 100);
  }

  function formatCurrency(cents) {
    // Shop-Format: €{{amount_with_comma_separator}} — Symbol VORN, Punkt als
    // Tausendertrenner, Komma als Dezimaltrenner.
    // ⚠ NICHT Intl mit style:'currency': das liefert fuer de-DE "1.915,90 €"
    // und stellte damit zwei Schreibweisen auf dieselbe Seite — oben
    // "€1.915,90", in der Sticky-Leiste "1.915,90 €" (Owner-Befund 21.09.2026).
    // toLocaleString ohne currency formatiert nur die ZAHL, das Symbol setzen wir.
    var n = (Number(cents) || 0) / 100;
    return '\u20AC' + n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function slug(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  function unique(items) {
    return Array.from(new Set(items.filter(Boolean)));
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function absoluteShopifyImage(value) {
    if (!value) return null;
    var string = String(value);
    if (string.indexOf('//') === 0) return window.location.protocol + string;
    return string;
  }

  function preloadImages(urls) {
    unique(urls).forEach(function (url) { preloadImage(url); });
  }

  function preloadImage(url, callback) {
    if (!url) {
      if (callback) callback();
      return;
    }
    var img = new Image();
    img.onload = function () { if (callback) callback(); };
    img.onerror = function () { if (callback) callback(); };
    img.src = url;
  }

  function lieferzeitLabel(key) {
    if (key === 'freight') return 'Speditionsversand · Termin nach Auftragsbestätigung';
    if (key === 'ral_made_to_order') return 'Sonderanfertigung · Lieferzeit nach Auftragsbestätigung';
    return 'Lieferzeit nach Auftragsbestätigung';
  }

  if (window.matchMedia && window.matchMedia('(max-width:820px)').matches) {
    var lift = function () {
      var badge = document.getElementById('google-merchantwidget-iframe-wrapper');
      if (!badge) return;
      // Der Observer beobachtet genau dieses style-Attribut. Ein blindes
      // erneutes setProperty loest deshalb seine eigene Callback-Kette aus
      // und kann den mobilen Hauptthread dauerhaft blockieren.
      if (badge.style.getPropertyValue('bottom') !== '88px'
        || badge.style.getPropertyPriority('bottom') !== 'important') {
        badge.style.setProperty('bottom', '88px', 'important');
      }
    };
    lift();
    // Das externe Widget darf seine Position nachladen. Ein kurzlebiges,
    // gedrosseltes Intervall reicht dafuer aus; ein Style-MutationObserver
    // kann mit dem Widget in eine gegenseitige Aenderungsschleife geraten.
    var timer = window.setInterval(lift, 700);
    window.setTimeout(function () { window.clearInterval(timer); }, 12000);
  }
})();
